import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom';

function Footer() {
   const  [email , setemail] = useState("");

   const EmailInput = (event)=>{
    const value = event.target.value;
      setemail(value)
     }
     const submitform = ()=>{
     }

  return (
   <>
   <footer className="footer-wrapper footer-layout1" data-bg-src="/assets/img/bg/footer-bg.png">
  <div className="shape-mockup footer-shape1 jump" data-left="60px" data-top="70px">
    <img src="/assets/img/normal/footer-bg-shape1.png" alt="img" />
  </div>
  <div className="shape-mockup footer-shape2 jump-reverse" data-right="80px" data-bottom="120px">
    <img src="/assets/img/normal/footer-bg-shape2.png" alt="img" />
  </div>
  <div className="footer-wrap" data-bg-src="/assets/img/bg/jiji.png">
    <div className="widget-area">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-md-6 col-xxl-3 col-xl-3">
            <div className="widget footer-widget">
              <div className="th-widget-about">
                <div className="about-logo">
                  <NavLink to="/"><img src="/assets/img/AA_LOgo_White.png" alt="Edura" /></NavLink>
                </div>
                <p className="about-text">Powered by Auratech Services India Pvt Ltd Leading IT A Software Development company based in Jaipur, offers Online and Offline Latest Job Oriented Technologies/ IT / Computer courses that helps to enhance skills with practicle knowledge</p>
                <div className="th-social">
                  <h6 className="title text-white">FOLLOW US ON:</h6>
                  <Link to="https://www.facebook.com/auratechindia//"><i className="fab fa-facebook-f" /></Link>
                  {/* <a href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a> */}
                  <Link to="https://www.linkedin.com/company/auratechindia"><i className="fab fa-linkedin-in" /></Link>
                  <Link to="https://www.youtube.com/@AURATECHACADEMY"><i className="fab fa-youtube" /></Link>
                  {/* <a href="https://www.skype.com/"><i class="fab fa-skype"></i></a> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xl-auto">
            <div className="widget widget_nav_menu footer-widget">
              <h3 className="widget_title">Quick Links</h3>
              <div className="menu-all-pages-container">
                <ul className="menu">
                  <li><NavLink to="/contact">Life Coach</NavLink></li>
                  <li><NavLink to="/contact">Business Coach</NavLink></li>
                  <li><NavLink to="/contact">Health Coach</NavLink></li>
                  <li><NavLink to="/contact">Development</NavLink></li>
                  <li><NavLink to="/contact">Web Design</NavLink></li>
                  <li><NavLink to="/contact">SEO Optimize</NavLink></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xl-auto">
            <div className="widget widget_nav_menu footer-widget">
              <h3 className="widget_title">Resources</h3>
              <div className="menu-all-pages-container">
                <ul className="menu">
                  <li><NavLink to="/contact">Community</NavLink></li>
                  <li><NavLink to="/contact">Support</NavLink></li>
                  <li><NavLink to="/contact">Video Guides</NavLink></li>
                  <li><NavLink to="/contact">Documentation</NavLink></li>
                  <li><NavLink to="/contact">Security</NavLink></li>
                  <li><NavLink to="/contact">Template</NavLink></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xxl-3 col-xl-3">
            <div className="widget newsletter-widget footer-widget">
              <h3 className="widget_title">Get in touch!</h3>
              <p className="footer-text">Subscribe our newsletter to get our latest
                Update &amp; news</p>

              <form className="newsletter-form form-group">
                <input className="form-control"
                type="email"
                onChange={EmailInput}
                value={email}
                placeholder="Email Email"
                required />
                <i className="far fa-envelope" />

                <button type="button"
                className="th-btn style3"
                onClick={submitform}
                >Subscribe Now <i className="far fa-arrow-right ms-1" /></button>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="copyright-wrap">
        <div className="row justify-content-between align-items-center">
          <div className="col-md-6">
            <p className="copyright-text">Copyright © 2024 <Link to="www.auratechacademy.com">Auratech® Academy</Link> All Rights Reserved.</p>
          </div>
          <div className="col-md-6 text-end  d-md-block">
            <div className="footer-links">
              <ul>
                <li><NavLink to="/about">Privacy Policy</NavLink></li>
                <li><NavLink to="/about">Terms &amp; Condition</NavLink></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>


   </>
  )
}

export default Footer